export enum AppPlatform {
  IOS = 1,
  Android = 2,
  Web = 3,
}
